// src/layouts/RootLayout.jsx
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Language from "../components/Language";

const RootLayout = () => {
  const location = useLocation();

  return (
    <>
      {/* Main page content */}
      <Outlet />

      {/* Show Language everywhere except /shortz */}
      {location.pathname !== "/shortz" && <Language />}
    </>
  );
};

export default RootLayout;
